import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

type UserId = number | 'me';

interface Query {
  expand?: string;
  excludeMoveOutOlderThan?: number;
  asAdvertiser?: boolean;
  state?:
    | 'all'
    | 'archived'
    | 'expired'
    | 'favorited'
    | 'inbox'
    | 'paid'
    | 'paidAndCancelled'
    | 'pending'
    | 'unread';
  limit?: number;
  listingId?: string | number;
  asTenant?: boolean;
  offset?: number;
  order?: string;
  text?: string;
  futureDates?: boolean;
  filterDate?: 'future' | 'current' | 'past';
}

export interface ConversationsResponse {
  conversations: Conversation[];
  count: number;
}

export default (makeCall: MakeCall) => (userId: UserId, query?: Query) =>
  makeCall<ConversationsResponse>(
    'GET',
    `${APIV2_URL}/conversations/user/${userId}`,
    {
      query,
    },
  );
